const currencySymbols = {
  RUB: '₽',
  UAH: '₴',
  USD: '$',
  KZT: '₸',
  BYR: 'Br',
  EUR: '€',
  BYN: 'Br',
  MNT: '₮',
  MDL: 'L',
  LKR: '₹',
  CNY: '¥',
  CHF: '₣',
  GBP: '£',
  TRY: '₺',
  MXN: 'MXN',
  EMPTY: ''
}

export default {
  methods: {
    toCurrency (num, currency = 'RUB') {
      if (currency === null || currency === '' || num === '—') {
        currency = ''
      }

      if (num === null) {
        return ' — '
      }

      if (!currencySymbols[currency]) {
        return num.toLocaleString(undefined, { minimumFractionDigits: 0 }) + ' ' + currency
      }

      return currency === 'USD' || currency === 'EUR' || currency === 'GBP' ? currencySymbols[currency] + num.toLocaleString(undefined, { minimumFractionDigits: 0 })
        : num.toLocaleString(undefined, { minimumFractionDigits: 0 }) + ' ' + currencySymbols[currency]
    }
  }
}
